// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__eI17C","gfeWrapper":"CalendarEvent_gfeWrapper__35o2h"};